import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import Collapse from 'common/components/Collapse/Collapse';

import messages from './Authority.intl';

import styles from './Authority.module.scss';

import ClippedImage from 'common/components/ClippedImage/ClippedImage';

@injectIntl
export default class AuthorityComponent extends Component {
  static propTypes = {
    name: PropTypes.string.isRequired,
    position: PropTypes.string.isRequired,
    text: PropTypes.string.isRequired,
    cite: PropTypes.string.isRequired,
    url: PropTypes.string.isRequired,
    achievements: PropTypes.string.isRequired,
    linkedInLink: PropTypes.string.isRequired
  };

  render() {
    const {
      className,
      name,
      position,
      text,
      cite,
      url,
      achievements,
      linkedInLink,
      cvLink
    } = this.props;

    return (
      <div className={`${styles.AuthorityComponent} ${className}`}>
        <div className={styles.Image}>
          <ClippedImage
            id="1"
            width={220}
            height={260}
            borderWidth={'1'}
            url={url}
          />
          <ClippedImage
            id="2"
            width={100}
            height={120}
            borderWidth={'1'}
            url={url}
          />
        </div>
        <div className={styles.TextWrapper}>
          <div className={styles.Signature}>
            <h3 className={styles.Name}>{name}</h3>
            <p className={styles.Position}>{position}</p>
          </div>
          <div className={styles.Description}>
            <div
              className={styles.Text}
              dangerouslySetInnerHTML={{ __html: text }}
            />
          </div>
          <div className={styles.Quote}>
            <h2 className={styles.Cite}>{cite}</h2>
          </div>
          <div className={styles.TextFooter}>
            <a
              href={linkedInLink}
              target="_blank"
              rel="noopener noreferrer nofollow"
              className={styles.IconWrapper}
            >
              <FontAwesomeIcon
                icon={['fab', 'linkedin-in']}
                size="sm"
                className={styles.Icon}
              />
            </a>
            <Collapse
              className={styles.Collapse}
              title={this.props.intl.formatMessage(messages.showExperience)}
            >
              <div dangerouslySetInnerHTML={{ __html: achievements }} />
            </Collapse>
          </div>
          <a
            href={cvLink}
            target="_blank"
            rel="noreferrer"
            className={styles.CVLink}
          >
            {this.props.intl.formatMessage(messages.showCV)}
          </a>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/views/Authorities/components/Authority/Authority.js